export const WALL_OF_LOVE_CARROUSEL = 'WALL_OF_LOVE_CAROUSEL';
export const WALL_OF_LOVE_TESTIMONIAL = 'WALL_OF_LOVE_TESTIMONIAL';
export const WALL_OF_LOVE_CARROUSEL_MOBILE = 'WALL_OF_LOVE_CARROUSEL_MOBILE';
